"use strict";
/**
 *  Usergroups used for authentication
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroups = void 0;
var UserGroups;
(function (UserGroups) {
    UserGroups["SalesmodeUser"] = "SalesmodeUser";
    UserGroups["PowermodeUser"] = "PowermodeUser";
    UserGroups["IgusPowermodeUser"] = "igusPowermodeUser";
})(UserGroups = exports.UserGroups || (exports.UserGroups = {}));
//# sourceMappingURL=UserGroups.js.map